import { DARK_VIOLET, GRAYSCALE_400, GRAYSCALE_300 } from "../../styles/colors";
import { INTER } from "../../styles/fonts";
import styled from "styled-components";

// ChevronWrapper component
export const ChevronWrapper = styled.div`
    padding-left: 16px;
`;

// IconContainer component
export const IconContainer = styled.div<{ disabled?: boolean }>`
    width: 36px;
    height: 36px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: linear-gradient(135deg, #64B5FFAA 0%, #9575CDAA 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 18px;
    margin-right: 16px;
    opacity: ${props => props.disabled ? 0.5 : 1};
`;

// ListItemContainer component
export const ListItemContainer = styled.div<{ disabled?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 8px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: background-color 0.2s;
    border-radius: 8px;
`;

// ContentWrapper component
export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

// TextContainer component
export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

// MethodTitle component
export const MethodTitle = styled.span<{ disabled?: boolean }>`
    font-family: ${INTER.regular};
    color: ${props => props.disabled ? GRAYSCALE_300 : DARK_VIOLET};
    font-size: 14px;
`;

// MethodDescription component
export const MethodDescription = styled.span<{ disabled?: boolean }>`
    font-family: ${INTER.regular};
    color: ${props => props.disabled ? GRAYSCALE_300 : GRAYSCALE_400};
    font-size: 12px;
`;
